import NotFound from "@/components/AppRouter/NotFound";
import CrossReference from "@/components/links/CrossReference/CrossReference";
import { PageHeader } from "@/components/PageHeader/PageHeader";
import Table from "@/components/Table/Table";
import TableHeader from "@/components/TableHeader/TableHeader";
import { useGetCompanies, useGetUsers } from "@/hooks/useAdmin";
import { useUserSettings } from "@/hooks/useUserSettings";
import { LinkOutlined } from "@ant-design/icons";
import { Button, Flex, Tag } from "antd";
import { Link } from "react-router-dom";

export default function UserAdmin() {
  const { data: userSettings } = useUserSettings();
  const { data: users, isLoading: usersLoading, isFetching: usersFetching } = useGetUsers();
  const { data: companies, isLoading: companiesLoading } = useGetCompanies();

  if (userSettings && userSettings.role !== "root_admin") {
    return <NotFound />;
  }

  return (
    <Flex
      vertical
      gap={12}
    >
      <PageHeader title="Users" />
      <div>
        <TableHeader
          left={
            <Link to={`/admin/users/${userSettings?.user_id}`}>
              <Button icon={<LinkOutlined />}>My user</Button>
            </Link>
          }
        />
        <Table
          loading={usersLoading || companiesLoading || usersFetching}
          data={users}
          columns={[
            { label: "ID", key: "id" },
            {
              label: "Name",
              key: "name",
              renderer: (record) => {
                return (
                  <>
                    {record.name}
                    {record.id === userSettings?.user_id && <Tag color="processing">It's you!</Tag>}
                  </>
                );
              },
            },
            { label: "Username", key: "username" },
            { label: "Email", key: "email" },
            {
              label: "Company",
              noLink: true,
              key: "company_id",
              renderer: (record) => {
                const company = companies?.find((c) => c.id === record.company_id);
                if (!company) return "Unknown";
                return (
                  <CrossReference to={`/admin/companies/${company.id}`}>
                    {company.id} - {company.name}
                  </CrossReference>
                );
              },
            },
            {
              label: "Role",
              key: "role",
            },
          ]}
          rowLink={(record) => `/admin/users/${record.id}`}
          rowKey={"id"}
        />
      </div>
    </Flex>
  );
}
